import React from 'react';
import { ResponsiveContainer, ComposedChart, Bar, Line, XAxis, YAxis, Tooltip as RTooltip } from 'recharts';
import { fmtCost, fmtDay } from './format';

const TooltipBox = ({ active, payload, label }) => {
  if (!active || !payload?.length) return null;
  const d = payload[0].payload;
  return (
    <div className="bg-[#0f172a] border border-[#1e293b] rounded-sm px-2.5 py-2 text-[11px]">
      <p className="text-slate-400">{label}</p>
      <p className="font-mono text-amber-400">{fmtCost(d.cost)}</p>
      <p className="font-mono text-slate-300">{d.calls} KI-Aufrufe</p>
      {d.mcp_calls > 0 && <p className="font-mono text-orange-300">{d.mcp_calls} Claude-Connect-Anfragen</p>}
    </div>
  );
};

export const CostDailyChart = ({ daily }) => {
  const data = daily.map(d => ({ ...d, label: fmtDay(d.date) }));
  const interval = data.length > 45 ? 6 : data.length > 20 ? 2 : 0;
  return (
    <div className="bg-card border border-border rounded-sm p-4" data-testid="ai-costs-daily-chart">
      <p className="font-heading text-base text-foreground">Tagesverlauf</p>
      <p className="text-[10px] text-muted-foreground mb-3">Balken: Kosten in USD · Linie: Claude-Connect-Anfragen</p>
      <ResponsiveContainer width="100%" height={220}>
        <ComposedChart data={data} margin={{ top: 5, right: 5, left: -15, bottom: 0 }}>
          <XAxis dataKey="label" tick={{ fontSize: 9, fill: '#64748b' }} interval={interval} axisLine={false} tickLine={false} />
          <YAxis yAxisId="cost" tick={{ fontSize: 9, fill: '#64748b' }} tickFormatter={(v) => `$${v}`} axisLine={false} tickLine={false} />
          <YAxis yAxisId="mcp" orientation="right" width={30} tick={{ fontSize: 9, fill: '#fdba74' }} allowDecimals={false} axisLine={false} tickLine={false} />
          <RTooltip content={<TooltipBox />} cursor={{ fill: 'rgba(148,163,184,0.08)' }} />
          <Bar yAxisId="cost" dataKey="cost" name="Kosten" fill="#f59e0b" radius={[2, 2, 0, 0]} maxBarSize={28} />
          <Line yAxisId="mcp" type="monotone" dataKey="mcp_calls" name="Claude Connect" stroke="#fdba74" strokeWidth={1.5} dot={false} />
        </ComposedChart>
      </ResponsiveContainer>
    </div>
  );
};
